import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import Component from './Component';
/**
 * The obj-model component loads a 3D model and material using a [Wavefront](https://en.wikipedia.org/wiki/Wavefront_.obj_file) (.OBJ) file and a .MTL file.
 *
 * @see https://aframe.io/docs/1.3.0/components/obj-model.html
 */

export var ObjModel = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ObjModel, _Component);

  function ObjModel() {
    return _Component.apply(this, arguments) || this;
  }

  return ObjModel;
}(Component);